const DEFAULT_DISPLAY_THRESHOLD_RATIO = 75;
export const DEFAULT_TEXTAREA_CHAR_MAX_LENGTH = 280;
export const defaultShouldDisplayCount = (count: number, maxLength: number): boolean =>
    (count / maxLength) * 100 >= DEFAULT_DISPLAY_THRESHOLD_RATIO;
